import { SVGProps } from 'react';

const SvgLink = (props: SVGProps<SVGSVGElement>) => (
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M13.3952 18.668C11.3873 16.6522 11.5681 13.2025 13.7992 10.9627L20.2627 4.47413C22.4938 2.23441 25.9302 2.05284 27.9381 4.06859C29.9461 6.08434 29.7652 9.53405 27.5342 11.7738L24.3024 15.0181"
      stroke="#2196F3"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M18.6049 13.332C20.6128 15.3478 20.432 18.7975 18.2009 21.0372L14.9692 24.2815L11.7374 27.5259C9.50633 29.7656 6.06991 29.9472 4.06195 27.9314C2.05399 25.9157 2.23486 22.4659 4.46593 20.2262L7.69772 16.9818"
      stroke="#2196F3"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export default SvgLink;
